import { useState } from "react";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const BillingPortalButton = ({ label = "Update card & billing", size = "sm", variant = "outline", className = "", testid = "billing-portal-btn" }) => {
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/billing/portal", {
        origin_url: window.location.origin,
        return_path: window.location.pathname,
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(apiError(e));
      setBusy(false);
    }
  };

  return (
    <Button size={size} variant={variant} className={`rounded-full ${className}`} data-testid={testid} disabled={busy} onClick={open}>
      <CreditCard size={13} className="mr-1.5" />
      {busy ? "Opening…" : label}
    </Button>
  );
};
